import { render, staticRenderFns } from "./inputPwd.vue?vue&type=template&id=4b69f20a&scoped=true"
import script from "./inputPwd.vue?vue&type=script&lang=js"
export * from "./inputPwd.vue?vue&type=script&lang=js"
import style0 from "./inputPwd.vue?vue&type=style&index=0&id=4b69f20a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69f20a",
  null
  
)

export default component.exports